/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlRequest {
    getFixupPrototypeFunction() { return ComplianceControlRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlRequest>): ComplianceControlRequest {
        let obj = Object.assign(new ComplianceControlRequest(), model);
        ComplianceControlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlRequest>): ComplianceControlRequest {
        if (!model) return null;
        return ComplianceControlRequest.newInstance(<ComplianceControlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlRequest) {
        if (!obj) return;

        models.ComplianceControlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceControlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the cloud account. The ID is unique, it can be obtained from the list cloud account api.
     */
    cloud_accounts: Array<string>;

    /**
     * URI of compliance_control. This can be fetched from controls mapped under standards.
     */
    compliance_control_uri: string;

}
